export default [
    {
        cardId: "1Events",
        card: [
            {
                cardRowId: "1_1Events",
                imgUrl: "reward.svg",
                title: "reward",
                cardDec: ''
            },
            {
                cardRowId: "1_1Events",
                imgUrl: "parents.svg",
                title: "Good Parents Points",
                cardDec: ''
            },
            {
                cardRowId: "1_1Events",
                imgUrl: "fitness.svg",
                title: "Cardio Hours Points",
                cardDec: ''
            },
        ]
    },
    {
        cardId: "2Events",
        card: [
            {
                cardRowId: "1_1Events",
                imgUrl: "kids.svg",
                title: "Good Kid Points",
                cardDec: ''
            },
            {
                cardRowId: "1_1Events",
                imgUrl: "sccoer.svg",
                title: "Soccer Power Points",
                cardDec: ''
            },
            {
                cardRowId: "1_1Events",
                imgUrl: "reading.svg",
                title: "Reading Hours Points",
                cardDec: ''
            },
        ]
    }
]


// artist.svg
// Artist Points

// leadership.svg
// Good Leadership Points

// speeling.png
// Spelling Power Points

// cooking.svg
// Cooking Power Points

// french.png
// French Skills Points

// chinese.svg
// Chinese Skills Points

// japanese.svg
// Japanese Skills Points

// english.png
// English Skills Points

// Cantonese.png
// Cantonese Skills Points

// charity.svg
// Charity Power Points

// Transformations.svg
// Transformations Points

// rehab.png
// Rehab Points

// Weight-loss.svg
// Weight loss Points

// Muscle.svg
// Muscle Gain Points

// Strength-training.svg
// Strength training Points

// Cardio-endurance.svg
// Cardio endurance Points

// Weight-training-b.svg
// Weight training b Points